<!-- <div class="row"> -->
<!-- <div class="col-10">
        <nav class="navbar navbar-expand-lg ">
            <img class="bcbsri-image" src="../../assets/images/bcbsri-new.PNG" alt="logo2">
        </nav>
    </div> -->
<!-- <span class = "helplogout">
        <div class="col-2">
          <a class="getHelp">Need&nbsp;Help</a>
      </div>
      </span> -->
<!-- </div> -->
<div class="container-fluid px-lg-5">
  <div class="row">
    <div class="col-12">
      <nav class="navbar navbar-expand-sm">
        <a class="navbar-brand" (click)="OnLogoClick()">
          <img class="bcbsri-image" src="../../assets/images/bcbsri-new.PNG" alt="logo2">
        </a>

        <ul class="nav ml-auto">
          <li><a class="pl-4" (click)="OnLogoClick()">Need&nbsp;Help</a></li>

          <!-- <li>
              <a class="pl-4" routerLink="/logout" routerLinkActive="active">Logout</a>
          </li> -->
        </ul>
      </nav>
    </div>
  </div>
</div>

<div class="panel panel-primary setup-content" id="step-4">
  <div class="panel-heading">
    <h3 class="panel-title">TERMS OF CONDITIONS</h3>
    <!-- <h5>Please Check Terms and Conditions before Submit.</h5> -->
  </div>
  <br>
  <div class="panel-body">
    <div class="form-group">

      <div class="cols-sm-10">
        <div class="input-group">
          <span class="input-group-addon"></span>

          <div class=WordSection1>
            <div class="bullet-margin">
              <p style="text-align: center;"><b>Developer Portal Terms and Conditions</b></p>

              <p>
                As a condition of using the Developer Portal created by Blue
                Cross &amp; Blue Shield of Rhode Island (BCBSRI), all registrants to the
                Developer Portal (Registrant) agree to the following:
              </p>

              <p>
                <span style='font-family:Symbol'>
                  ·<span style='font:7.0pt "Times New Roman"'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>
                Registrant agrees to only use the API to retrieve individual
                member data at the request of the member, and only when the member has
                authorized such access via a HIPAA-qualified authorization.  Registrant will
                cease to access data if the member consent is revoked.  Registrant will notify
                BCBSRI if any consent is revoked.
              </p>

              <p>
                <span style='font-family:Symbol'>
                  ·<span style='font:7.0pt "Times New Roman"'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>Registrant agrees to use data accessed through the API only in
                accordance with applicable law, the terms of its privacy policy and the terms
                of the member consent.
              </p>

              <p>
                <span style='font-family:Symbol'>
                  ·<span style='font:7.0pt "Times New Roman"'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>Registrant agrees to keep its credentials for the Developer
                Portal confidential.  Assignment of credentials is not permitted.  Registrant
                will notify BCBSRI of any change in control and submit a new registration
                application.
              </p>

              <p>
                <span style='font-family:Symbol'>
                  ·<span style='font:7.0pt "Times New Roman"'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>Registrant will notify member of any breach or misuse of data as
                required by state and federal laws.
              </p>

              <p>
                <span style='font-family:Symbol'>
                  ·<span style='font:7.0pt "Times New Roman"'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>
                Registrant will notify BCBSRI immediately of any security
                incident that may impact the security of BCBSRI’s systems or data.
              </p>

              <p>
                <span style='font-family:Symbol'>
                  ·<span style='font:7.0pt "Times New Roman"'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>Registrant will indemnify BCBSRI for any and all claims, damages
                or expenses, including but not limited to attorneys’ fees resulting from
                Registrant’s improper use of the API, improper disclosure of any data accessed
                through the API, or any violation of the member’s consent, the terms of this
                agreement, or any applicable laws.
              </p>

              <p>
                <span style='font-family:Symbol'>
                  ·<span style='font:7.0pt "Times New Roman"'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>Registrant agrees that in any dispute between Registrant and
                BCBSRI, Rhode Island law will apply without regard to conflict of law
                principles, and jurisdiction will be appropriate in any Rhode Island state or
                federal court only.
              </p>

              <p>
                <span style='font-family:Symbol'>
                  ·<span style='font:7.0pt "Times New Roman"'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>Registrant acknowledges that data accessed through the API is
                provided with no warranty as to accuracy, and BCBSRI does not guarantee
                uninterrupted access to the API.  Registrant expressly waives any right to seek
                damages from BCBSRI related to Registrant’s use of the API or denial of access
                to the API.
              </p>

              <p>BCBSRI retains the right to:</p>

              <p>
                <span style='font-family:Symbol'>
                  ·<span style='font:7.0pt "Times New Roman"'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>Limit access to the API at any time in its sole discretion as
                necessary to protect BCBSRI’s system or prevent abuse.
              </p>

              <p>
                <span style='font-family:Symbol'>
                  ·<span style='font:7.0pt "Times New Roman"'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>Conduct a security assessment of any registered application, and
                provide information to the member as to the outcome of the assessment.  In the
                event that BCBSRI determines that allowing an application to connect or remain
                connected to the API would present an unacceptable level of risk to the
                security of protected health information on BCBSRI’s system, BCBSRI reserves
                the right to deny access to the API.
              </p>

              <p>
                <span style='font-family:Symbol'>
                  ·<span style='font:7.0pt "Times New Roman"'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>Validate and authenticate member’s identity and consent before
                allowing access to the API.
              </p>

              <p>
                <span style='font-family:Symbol'>
                  ·<span style='font:7.0pt "Times New Roman"'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                </span>Revoke access to the API if registrant provides any false
                information in its registration application, engages in any inappropriate use
                of the API, or violates the terms of the member’s consent, these terms and
                conditions or any applicable law.
              </p>
            </div>
            <!-- <textarea readonly class="form-control textarea" name="terms" id="terms" placeholder="There will be Terms and Conditions.There will be Terms and Conditions.I know this post has been (very well) answered by Aquarelle but just in case somebody is having this issue with other tag forms with no text such as inputs i'll leave this here:

            If you have an input in your form and placeholder is not showing because a white space at the beginning, this may be caused for you value attribute. In case you are using variables to fill the value of an input check that there are no white spaces between the commas and the variables.

            example using twig for php framework symfony :"></textarea> -->
          </div>
        </div>
      </div>
